
<template class="">
    <nav class="pf ov ba bgBlack z1000 pv10" style="border-bottom-left-radius: 3rem; border-bottom-right-radius: 3rem;">
      <div class="flexi m_ph15">
        <div class="headerNavDiv">
          <div class="l" style="width: 125px;"><router-link :to="{ name: 'Home' }"><img src="@/assets/imgs/logoV1.png" alt="logo" title="trendshift" class="w100"></router-link></div>
          <div class=" m_h c navBarMenu ph15 pv10" style="min-width: 60%">
            <div class="g_nm ph10"><div class="navItem fs18" :class="{'active' : $route.name == 'Home' && $route.hash == '' }"><router-link :to="{ name: 'Home' }">{{ $t('Home') }}</router-link></div></div>
            <div class="g_nm ph10"><div class="navItem fs18" :class="{'active' : $route.hash == '#activities' }"><router-link :to="{ name: 'Home' , hash:'#activities'}">{{ $t('Activities') }}</router-link></div></div>
            <div class="g_nm ph10"><div class="navItem fs18" :class="{'active' : $route.hash == '#services' }"><router-link :to="{ name: 'Home' , hash:'#services'}">{{ $t('Services') }}</router-link></div></div>
            <div class="g_nm ph10"><div class="navItem fs18" :class="{'active' : $route.hash == '#memberships' }"><router-link :to="{ name: 'Home' , hash:'#memberships'}">{{ $t('Memberships') }}</router-link></div></div>
            <div class="g_nm ph10"><div class="navItem fs18" :class="{'active' : $route.hash == '#ranks' }"><router-link :to="{ name: 'Home' , hash:'#ranks'}">{{ $t('Ranks') }}</router-link></div></div>
            <!-- <div class="g_nm ph10"><div class="navItem fs18" @click="goToHome">{{ $t('Contact us') }}</div></div> -->
            <!-- <div class="g_nm ph10"><div class="navItem fs18" :class="{'active' : $route.name == 'terms' }"><router-link :to="{ name: 'terms' }">{{ $t('Terms of Use') }}</router-link></div></div> -->
          </div>
          <div class="r">
            <router-link :to="{ name: 'SignIn' }" class=""><button class="navBtn">{{ $t('Sign in Page') }} <Icon icon="solar:login-bold" width="16" height="16" class="vm ml5" /></button></router-link>
            <Icon icon="solar:global-bold" width="30" height="30" style="color: #fff" class="vm ml8 mr8 pointer" @click="changeLang()" /> 
            <Icon icon="solar:hamburger-menu-bold" width="25" height="25" style="color: #fff" class="vm pointer h m_sib" @click="openSideBar()" />
          </div>
        </div>
        
      </div>
    </nav>
    <div class=" mainDiv">
      <router-view></router-view>
    </div>
    <div class="pv8 bgOrange"></div>
    <div class="bgb pt50">
      <div class="" id="contactus">
        <!-- <tbl fixed>
          <cl class=" w60 vm c">
            <div class="contactEmpty title fs160 lh160 m_fs100 m_lh100  ld_fs120 ld_lh120 md_fs100 md_lh100 upper">
              <p>{{ $t('Contact') }}</p>
              <p>{{ $t('US!') }}</p>
            </div>
            <div class="cc upper fs120  lh100 ld_fs100 ld_lh90 md_fs90 md_lh80 m_fs80 m_lh70">
              <p class="cw">{{ $t('Contact') }}</p>
              <p class="cOrange">{{ $t('US!') }}</p>
            </div>
            <div class="mt30">
              <a  class='g_nm p5' target="_blank" href="https://wa.me/96171839413?text=Hello%20Trends%20Shift%20Support"><button class="contactBtn fs20"><Icon icon="ic:outline-whatsapp" width="25" height="25" class=""/><span class="ml4 mt4">{{ $t('Whatsapp') }}</span></button></a>
            <a  class='g_nm p5' target="_blank" href="mailto:info@trendsshift.com"><button class="contactBtn fs20"><Icon icon="streamline-logos:email-logo-solid" width="25" height="25" class=""/> <span class="ml4 mt4 ">{{ $t('Email') }}</span></button></a>
            </div>
          </cl>
          <cl class="w40 vm l m_c cw m_pt30">
            <div class="fs30 c pr50 m_ph25">{{ $t('Trend Shift is a trading company licensed in Lebanon with license number 3024596, headquartered in Lebanon.') }}</div>
            <div class="fs30 c pr50 m_ph25">{{ $t('Its main activities include: buying and selling, brokerage, and online marketing.') }}</div>

          </cl>
        </tbl> -->
        <!-- <div class="pv2 round4x bgBlack mt40 mb40"></div> -->
        <div class="ph25">
          <div class="round4x bgBlack pv20 ph20">
            <tbl>
              <cl class="w33 vt">
                <div class="round3x p20" style="background-color: #424242;">
                <div class="fs30 b cOrange mb10">{{ $t('For Inquiries') }}</div>
                  <div class="mt10 fs18">
                    <tbl_nm>
                      <cl class="vm cOrange pt4" style="width: 40px;"><Icon icon="mdi-light:phone" width="25" height="25"/></cl>
                      <cl class="wa vm  cw l"><a href="https://wa.me/96171839413?text=Hello%20Trends%20Shift%20Support" target="_blank">96171839413</a></cl>
                    </tbl_nm>
                  </div>
                  <div class="mt10 fs18">
                    <tbl_nm>
                      <cl class="vm cOrange pt4" style="width: 40px;"><Icon icon="streamline-logos:email-logo-solid" width="25" height="25" class=""/> </cl>
                      <cl class="wa vm  cw l"><a href="mailto:info@trendsshift.com" target="_blank">info@trendsshift.com</a></cl>
                    </tbl_nm>
                  </div>
                  <div class="mt10 fs18">
                    <tbl_nm>
                      <cl class="vm cOrange pt4" style="width: 40px;"><Icon icon="mdi:location" width="25" height="25"/></cl>
                      <cl class="wa vm  cw l">{{ $t('Tripoli - Lebanon') }}</cl>
                    </tbl_nm>
                  </div>
                </div>
              </cl>
              <cl class="colSep30 pv20"></cl>
              <cl class="w33 vt">
                <div class="fs30 b cOrange mb10">{{ $t('Menu') }}</div>
                  <div class="mt10 fs18"><router-link class="footerLink " :to="{ name: 'Home' }">{{ $t('Home') }}</router-link></div>
                  <div class="mt10 fs18"><router-link :to="{ name: 'Home' , hash:'#activities'}" class="footerLink">{{ $t('Activities') }}</router-link></div>
                  <div class="mt10 fs18"><router-link :to="{ name: 'Home' , hash:'#services'}" class="footerLink">{{ $t('Services') }}</router-link></div>
                  <div class="mt10 fs18"><router-link :to="{ name: 'Home' , hash:'#memberships'}" class="footerLink">{{ $t('Memberships') }}</router-link></div>
                  <div class="mt10 fs18"><router-link :to="{ name: 'Home' , hash:'#ranks'}" class="footerLink">{{ $t('Ranks') }}</router-link></div>
                  <!-- <div class="mt10 fs18"><a  href="/#contact" class="footerLink">{{ $t('Contact us') }}</a></div> -->
                  <!-- <div class="mt10 fs18"><router-link class="footerLink " :to="{ name: 'terms' }">{{ $t('Terms of Use') }}</router-link></div> -->
              </cl>
              <cl class="colSep30 pv20"></cl>
              <cl class="w33 vt cw">
                <div class="g_nm c">
                  <div class="fs30 b cOrange fs18 mb10">{{ $t('Our Services') }}</div>
                  <div class="mt10 pl10"><router-link class="footerLink" :to="{ name:'TS8'}">{{ $t('Digital Currency') }}</router-link></div>
                  <div class="mt10 pl10"><router-link class="footerLink" :to="{ name:'Market'}">{{ $t('Market') }}</router-link></div>
                  <div class="mt10 pl10"><router-link class="footerLink" :to="{ name:'Signals'}">{{ $t('Signals') }}</router-link></div>
                  <div class="mt10 pl10"><router-link class="footerLink" :to="{ name:'Academy'}">{{ $t('Academy') }}</router-link></div>
                  <div class="mt10 pl10"><router-link class="footerLink" :to="{ name:'Affiliate'}">{{ $t('Affiliate') }}</router-link></div>
                  <div class="mt10 pl10"><router-link class="footerLink" :to="{ name:'RealEstateFund'}">{{ $t('Real Estate Fund') }}</router-link></div>
                </div>
              </cl>
            </tbl>
          </div>
        </div>

        <div class="mt20 pv20 bgBlack" style="border-top-left-radius: 4rem; border-top-right-radius: 4rem;">
          <div class="fs40 cOrange">{{ $t('Follow Us:') }}</div>
          <div class="g_nm p10"><a target="_blank" href="https://www.tiktok.com/@trends.shift?_r=1&_t=ZS-92s3PxGBKBE"><div class="g_nm round3x p17 footerIcon"><Icon class="cc" icon="ic:outline-tiktok" width="30" height="30" /></div></a></div>
          <div class="g_nm p10"><a target="_blank" href="https://t.me/+CkHpcqY9naoyOGQ0"><div class="g_nm round3x p17 footerIcon"><Icon class="cc" icon="ic:outline-telegram" width="30" height="30" /></div></a></div>
          <div class="g_nm p10"><a target="_blank" href="https://www.instagram.com/trends_shift/#"><div class="g_nm round3x p17 footerIcon"><Icon class="cc" icon="mdi:instagram" width="30" height="30" /></div></a></div>
          <div class="g_nm p10"><a target="_blank" href="https://www.facebook.com/profile.php?id=61566877715735&mibextid=JRoKGi"><div class="g_nm round3x p17 footerIcon"><Icon class="cc" icon="ic:outline-facebook" width="30" height="30" /></div></a></div>

        </div>
      </div>
    </div>
    <div class="pf ov blackSideBar" @click="closeSideBar()"></div>
    <div class="pf ov whiteSideBar" @click="closeSideBar()"></div>
    <div class="pf ov orangeSideBar l" @click.self="closeSideBar()">
      <div class="pv30 ph10 oya" style="max-height: 80vh;" @click.stop>
        <div class="ov10 la ba"><Icon icon="mingcute:close-fill" width="40" height="40" style="color: #fff" class="pointer" @click="closeSideBar()" /></div>
        <img src="@/assets/imgs/logoV2.png" alt="logo" class="w90 g_nm" style="max-width: 140px">
        <div class="mt30 l">
          <div class="mt10"><div class="navItem navItemMob fs20" @click="closeSideBar()"><router-link :to="{ name: 'Home' }">{{ $t('Home') }}</router-link></div></div>
          <div class="mt10"><div class="navItem navItemMob fs20" @click="closeSideBar()"><router-link :to="{ name:'Home', hash: '#activities' }">{{ $t('Activities') }}</router-link></div></div>
          <div class="mt10"><div class="navItem navItemMob fs20" @click="closeSideBar()"><router-link :to="{ name:'Home', hash: '#services' }">{{ $t('Services') }}</router-link></div></div>
          <div class="mt10"><div class="navItem navItemMob fs20" @click="closeSideBar()"><router-link :to="{ name:'Home', hash: '#memberships' }">{{ $t('Memberships') }}</router-link></div></div>
          <div class="mt10"><div class="navItem navItemMob fs20" @click="closeSideBar()"><router-link :to="{ name:'Home', hash: '#ranks' }">{{ $t('Ranks') }}</router-link></div></div>
          <!-- <div class="mt10"><div class="navItem navItemMob fs20" @click="closeSideBar()"><router-link :to="{ name: 'terms' }">{{ $t('Terms of Use') }}</router-link></div></div> -->
          <div class="mt20">
            <router-link :to="{ name: 'SignIn' }"><button class="navBtn" @click="closeSideBar()"><Icon icon="solar:login" width="16" height="16" class="vm mr5" /> {{ $t('Sign in Page') }}</button></router-link>
          </div>
        </div>
      </div>
    </div>
  <div v-if="$store.state.loader==1 || $store.state.pageLoader==1" class="pf ov bgw" style="z-index: 9999999;">
    <div class="cc">
      <div class="loader">$</div>
    </div>
  </div>
</template>
<script>
import router from '@/router';
import { routerKey } from 'vue-router';


export default {
    name: "WebLayout",
    data() {
      return {
      };
    },
    created(){
      if(this.$cookies.isKey("_TrendLang")){
      if(this.$cookies.get("_TrendLang")=='en'){
        this.$i18n.locale='ar';
      }
      else{
        this.$i18n.locale='en';
      }
      this.changeLang()
    }
    },
    mounted() {
      // Add event listener for clicks outside sidebar
      document.addEventListener('click', this.handleClickOutside);
    },
    beforeUnmount() {
      // Remove event listener when component is destroyed
      document.removeEventListener('click', this.handleClickOutside);
    },
    methods:{
      changeLang(){
        if(this.$i18n.locale=="en"){
          $('html').attr('lang', 'ar');  
          this.$i18n.locale='ar';
          $('body').addClass('rtl');
          const expirationTime =  10000 * 60 * 60;
          this.$cookies.set("_TrendLang", 'ar', expirationTime);
        }
        else{
          $('html').attr('lang', 'en');  
          this.$i18n.locale='en';
          $('body').removeClass('rtl');
          const expirationTime =  10000 * 60 * 60;
          this.$cookies.set("_TrendLang", 'en', expirationTime);
        }
      },
      openSideBar(){
        $('.blackSideBar').addClass('active')
        $('.orangeSideBar').addClass('active')
        $('.whiteSideBar').addClass('active')
      },
      closeSideBar(){
        $('.blackSideBar').removeClass('active')
        $('.orangeSideBar').removeClass('active')
        $('.whiteSideBar').removeClass('active')
      },
      handleClickOutside(event) {
        // Check if sidebar is open
        const isSidebarOpen = $('.orangeSideBar').hasClass('active');
        
        if (isSidebarOpen) {
          // Check if click is outside the sidebar content area
          const orangeSidebar = document.querySelector('.orangeSideBar');
          const isClickInsideSidebar = orangeSidebar && orangeSidebar.contains(event.target);
          
          // Check if click is on hamburger menu button (to prevent immediate close when opening)
          const isHamburgerClick = event.target.closest('.h.m_sib');
          
          if (!isClickInsideSidebar && !isHamburgerClick) {
            this.closeSideBar();
          }
        }
      },
      goToHomeAndClose() {
        this.goToHome();
        this.closeSideBar();
      },
    goToHome() {
      if (this.$route.name === 'Home') {
        // Scroll to the div with id "contactus"
        const contactUsDiv = document.getElementById('contactus');
        if (contactUsDiv) {
          contactUsDiv.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // Navigate to the Home route with query parameter q=contactus
        this.$router.push({ name: 'Home', query: { q: 'contact-us' } });
      }
    }
  }

    
  }
  
</script>
<style>
.p17{
  padding: 17px;
}
.navItemMob:hover{
  color: #fff !important;
}
</style>